module.exports = __webpack_public_path__ + "img/16.f50bbd77.jpg";